// Meter (Primitives; was primitives.tsx's, HIERARCHY follow-up 9, BL-189): a bar against a scale, with
// marks (a target, a floor). A drawing, so it keeps its frame: the fill in ink or a technician's pen,
// hatched for what's over or still to come, red when low or bad; a target is an ink line across it, a
// floor a dashed red one. It keeps base.css's classes (.flw-meter, .flw-mark), which page sheets size and
// place it by (performance.css's .perf-conv .flw-meter). Reads only --meter-*.
import type { CSSProperties } from 'react';
import { penStyle, type Pen } from '../pen.ts';
import './Meter.css';

export interface Mark {
  at: number;
  kind?: 'target' | 'floor';
  label?: string;
}

export interface MeterProps {
  value: number;
  /** The scale's end (100). */
  max?: number;
  /** What it measures, for screen readers ("Revenue against the goal"). */
  label: string;
  marks?: Mark[];
  state?: 'ok' | 'low' | 'over' | 'bad';
  fill?: 'solid' | 'hatch';
  /** A technician's pen, 1 to 8, for the fill. */
  pen?: number;
}

/** A bar against a scale, with marks (a target, a floor). A drawing, so it keeps its frame. */
export function Meter(p: MeterProps) {
  const max = p.max ?? 100;
  const pct = (v: number) => `${Math.max(0, Math.min(100, (v / (max || 1)) * 100))}%`;
  return (
    <span
      className={`flw-meter flw-meter-${p.state ?? 'ok'} flw-meter-${p.fill ?? 'solid'}`}
      role="meter"
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={p.value}
      aria-label={p.label}
      style={penStyle('meter', (p.pen ?? null) as Pen | null) as CSSProperties | undefined}
    >
      <i style={{ width: pct(p.value) }} />
      {(p.marks ?? []).map((m, i) => (
        <b
          key={i}
          className={`flw-mark flw-mark-${m.kind ?? 'target'}`}
          style={{ left: pct(m.at) }}
          title={m.label}
        />
      ))}
    </span>
  );
}
